export { defaultPlugin } from 'src/lib/site-resolver/plugins/default';
export { multisitePlugin } from 'src/lib/site-resolver/plugins/multisite';
